import styles from './NewBadge.module.scss'

const NewBadge = ({ className, children = 'new', style, animated = false }) => (
  <span
    style={style}
    className={[styles.badge, animated && styles.badgeAnimated, className].filter(Boolean).join(' ')}
  >
    {children}
  </span>
)

export default NewBadge
